import { createTextVNode as _createTextVNode } from "vue";
import { createVNode as _createVNode } from "vue";
import "core-js/modules/esnext.iterator.map.js";
import { createFormItem } from "@/component-create/utils/create-form-item";
import { FormDialog } from "@/component-create/FormDialog";
import { FORM_ITEM } from "@/components/form/enums";
import { MAIL_BASE_URL, send } from "@/api/system/mail";
import { MAIL_TYPE } from "@/constant/system/code";
import { ElTag } from 'element-plus';
import 'element-plus/es/components/tag/style/css'

import { toast } from "@/utils/message";
/**
 * 绘制新增表单
 */
export function renderSendForm(el) {
  const addForm = new FormDialog(el, {
    items: items,
    loadUrl: MAIL_BASE_URL
  }, '发送', [{
    text: '取消',
    type: 'default',
    handler: () => {
      addForm.close();
    }
  }, {
    text: '发送',
    type: 'primary',
    handler: formData => {
      if (formData.properties) {
        try {
          JSON.parse(formData.properties);
        } catch (e) {
          toast.error('参数格式错误,无法解析为JSON对象');
          return;
        }
      }
      addForm.showLoading();
      send({
        mailCode: formData.mailCode,
        properties: formData.properties
      }).then(() => {
        toast.success('邮件发送成功');
        addForm.close();
      }).finally(() => {
        addForm.closeLoading();
      });
    }
  }]);
  return addForm;
}
const items = [[createFormItem('主题', 'mailSubject', form => {
  return h(_createVNode("div", null, [form.value.mailSubject]));
})], [createFormItem('内容', 'mailContent', form => {
  if (form.value['mailType'] === MAIL_TYPE.HTML.CODE) {
    return h(_createVNode("div", {
      "style": {
        overflowY: 'auto'
      },
      "innerHTML": form.value.mailContent
    }, null));
  } else {
    return h(_createVNode("div", {
      "textContent": form.value.mailContent
    }, null));
  }
})], [createFormItem('收件', 'to', form => {
  if (!form.value.to) {
    return h(_createVNode("div", null, null));
  }
  return h(_createVNode("div", null, [form.value.to.map(i => {
    return _createVNode(ElTag, {
      "style": {
        margin: '2px'
      },
      "size": "small"
    }, {
      default: () => [i.recipientName, _createTextVNode(":"), i.mailAddress]
    });
  })]));
})], [createFormItem('抄送', 'cc', form => {
  if (!form.value.cc) {
    return h(_createVNode("div", null, null));
  }
  return h(_createVNode("div", null, [form.value.cc.map(i => {
    return _createVNode(ElTag, {
      "style": {
        margin: '2px'
      },
      "type": "success",
      "size": "small"
    }, {
      default: () => [i.recipientName, _createTextVNode(":"), i.mailAddress]
    });
  })]));
})], [createFormItem('密送', 'bcc', form => {
  if (!form.value.bcc) {
    return h(_createVNode("div", null, null));
  }
  return h(_createVNode("div", null, [form.value.bcc.map(i => {
    return _createVNode(ElTag, {
      "style": {
        margin: '2px'
      },
      "type": "info",
      "size": "small"
    }, {
      default: () => [i.recipientName, _createTextVNode(":"), i.mailAddress]
    });
  })]));
})], [createFormItem('参数', 'property', FORM_ITEM.INPUT, {
  type: 'textarea',
  rows: 3,
  maxlength: '1000',
  showWordLimit: true
})]];